{
  "v2.profils.code.BROUILLON_VIDE": "Nothing to submit: this draft is empty.",
  "v2.profils.code.CONFIRMATION_IDENTITE_ECHOUEE": "Identity not confirmed: incorrect secret.",
  "v2.profils.code.CONFIRMATION_IDENTITE_REQUISE": "Identity confirmation required.",
  "v2.profils.code.CONFLIT_CONCURRENT": "The profile changed since you read it: reload it before continuing.",
  "v2.profils.code.CONTEXTE_INCOMPLET": "The context needed to check rights is incomplete.",
  "v2.profils.code.DELAI_DE_REFLEXION_EN_COURS": "The cooling-off period has not elapsed.",
  "v2.profils.code.DROIT_ISOLE_INTROUVABLE": "This individual right no longer exists.",
  "v2.profils.code.DROIT_NON_PROPOSABLE": "A chosen right cannot be part of a profile.",
  "v2.profils.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v2.profils.code.EMPREINTE_PERIMEE": "The revision changed since its submission: read it again.",
  "v2.profils.code.ETAT_INVALIDE": "This action is not possible in the profile's current state.",
  "v2.profils.code.MOTIF_TROP_COURT": "The reason must be at least 15 characters long.",
  "v2.profils.code.PROFIL_DEPART_NON_MODIFIABLE": "A starting profile cannot be edited: duplicate it.",
  "v2.profils.code.PROFIL_DEPART_NON_RETIRABLE": "A starting profile cannot be withdrawn.",
  "v2.profils.code.PROFIL_INTROUVABLE": "This profile cannot be found.",
  "v2.profils.code.PROFIL_NIVEAU_INCOMPATIBLE": "A chosen right cannot be part of a profile of this level.",
  "v2.profils.code.PROFIL_NOM_DEJA_PRIS": "This profile name is already taken.",
  "v2.profils.code.PROFIL_TENU": "This profile is held by people: remove it from them first.",
  "v2.profils.code.RETRAIT_RESERVE_A_L_AUTEUR": "Only the person who submitted can withdraw the submission.",
  "v2.profils.code.TROP_DE_TENTATIVES": "Too many attempts: try again later.",
  "v2.profils.code.VALIDATION_ERROR": "A filter is invalid.",
  "v2.profils.code.VALIDATION_PAR_UN_TIERS": "Validation by another person is required.",
  "v2.profils.code.VERSION_FIGEE": "This revision is frozen: it can no longer be changed.",
  "v2.profils.code.VERSION_INTROUVABLE": "This profile version cannot be found.",
  "v2.profils.col.actions": "Actions",
  "v2.profils.col.etat": "Status",
  "v2.profils.col.niveau": "Level",
  "v2.profils.col.nom": "Name",
  "v2.profils.col.origine": "Origin",
  "v2.profils.col.personnes": "People holding it",
  "v2.profils.creer": "Create a profile",
  "v2.profils.depart.duplicable": "not editable, can be duplicated",
  "v2.profils.editeur.annule_validation": "Any saved change cancels a pending validation.",
  "v2.profils.editeur.confirmation.aide": "Identity confirmation required for this action; the secret is not kept.",
  "v2.profils.editeur.confirmation.publier": "Password or second-factor code (publish)",
  "v2.profils.editeur.confirmation.requise.publier": "Confirm your identity to publish.",
  "v2.profils.editeur.confirmation.requise.valider": "Confirm your identity to validate.",
  "v2.profils.editeur.confirmation.valider": "Password or second-factor code (validate)",
  "v2.profils.editeur.contenu": "Profile content",
  "v2.profils.editeur.decision": "Decision",
  "v2.profils.editeur.delai": "Cooling-off period until {{date}}.",
  "v2.profils.editeur.droits": "Profile rights",
  "v2.profils.editeur.droits.non_proposes": "Rights reserved to the owner and personal rights are not offered.",
  "v2.profils.editeur.ecarts": "Differences with the published version",
  "v2.profils.editeur.ecarts.ajoutes": "Rights added: {{droits}}",
  "v2.profils.editeur.ecarts.aucun": "No other published version: no difference.",
  "v2.profils.editeur.ecarts.personnes": "{{n}} people affected",
  "v2.profils.editeur.ecarts.retires": "Rights removed: {{droits}}",
  "v2.profils.editeur.echec": "The action did not complete.",
  "v2.profils.editeur.enregistre": "Draft saved.",
  "v2.profils.editeur.enregistrer": "Save the draft",
  "v2.profils.editeur.enregistrer_avant": "Save the draft before submitting it.",
  "v2.profils.editeur.etat": "Publication status",
  "v2.profils.editeur.fermer": "Close",
  "v2.profils.editeur.fige": "Revision submitted, frozen by its fingerprint ({{empreinte}}…): no change possible.",
  "v2.profils.editeur.motif": "Reason for refusal",
  "v2.profils.editeur.motif_refus": "Refused: {{motif}}",
  "v2.profils.editeur.nature": "Profile nature",
  "v2.profils.editeur.nature.administration": "Copy of an administration profile: inherited downwards, it can be replaced there.",
  "v2.profils.editeur.nature.travail": "Work profile: a profile set lower down replaces it.",
  "v2.profils.editeur.niveau": "Profile level",
  "v2.profils.editeur.nom": "Profile name",
  "v2.profils.editeur.nom.requis": "Give the profile a name.",
  "v2.profils.editeur.nouveau": "New profile",
  "v2.profils.editeur.prerequis": "Read prerequisites added: {{droits}}.",
  "v2.profils.editeur.publication": "Publication",
  "v2.profils.editeur.publier": "Publish",
  "v2.profils.editeur.refuse": "Revision refused.",
  "v2.profils.editeur.refuser": "Refuse",
  "v2.profils.editeur.relue_autre": "The profile was changed elsewhere while you were editing: your input is kept; saving may be refused, reload to resume the version read.",
  "v2.profils.editeur.retire_lecture_seule": "Profile withdrawn: read only.",
  "v2.profils.editeur.retire_validation": "Submission withdrawn: the revision is a draft again.",
  "v2.profils.editeur.retirer_validation": "Withdraw from validation",
  "v2.profils.editeur.separation": "Separation of duties",
  "v2.profils.editeur.separation.alerte": "Combination flagged: {{creer}} with {{approuver}}; no effect on the third-party validation rule.",
  "v2.profils.editeur.separation.aucune": "No combination to report.",
  "v2.profils.editeur.soumettre": "Submit for validation",
  "v2.profils.editeur.supprimer": "Delete the draft",
  "v2.profils.editeur.supprimer.consequence": "The draft is deleted; a never-published profile disappears with it.",
  "v2.profils.editeur.supprimer.titre": "Delete the {{nom}} draft?",
  "v2.profils.editeur.supprimer.verbe": "Delete",
  "v2.profils.editeur.titre": "Profile — editor",
  "v2.profils.editeur.valide": "Revision validated.",
  "v2.profils.editeur.valider": "Validate",
  "v2.profils.etat.chargement": "Loading: {{quoi}}…",
  "v2.profils.etat.erreur": "Could not load: {{quoi}}.",
  "v2.profils.etat.reessayer": "Retry",
  "v2.profils.etat.refus": "Access refused: {{quoi}}.",
  "v2.profils.etat_profil.brouillon": "Draft",
  "v2.profils.etat_profil.en_validation": "Under validation",
  "v2.profils.etat_profil.publie": "Published",
  "v2.profils.etat_profil.refuse": "Refused",
  "v2.profils.etat_profil.retire": "Withdrawn",
  "v2.profils.etat_profil.valide": "Validated",
  "v2.profils.fiche.chargement": "Loading the profile…",
  "v2.profils.fiche.de_l_organisation": "Organisation profile",
  "v2.profils.fiche.depart": "Platform starting profile, not editable",
  "v2.profils.fiche.depart_non_modifiable": "Starting profile cannot be edited: duplicate it.",
  "v2.profils.fiche.depart_non_retirable": "A starting profile cannot be withdrawn.",
  "v2.profils.fiche.droits": "Profile rights",
  "v2.profils.fiche.droits.reserves": "Rights reserved to the owner are never part of a profile.",
  "v2.profils.fiche.droits.vide": "No right.",
  "v2.profils.fiche.dupliquer": "Duplicate the profile",
  "v2.profils.fiche.dupliquer.aide": "The copy is an organisation draft; reserved rights are never copied.",
  "v2.profils.fiche.dupliquer.echec": "The profile was not duplicated.",
  "v2.profils.fiche.dupliquer.nom": "Name of the copy",
  "v2.profils.fiche.erreur": "The profile could not be loaded.",
  "v2.profils.fiche.heritage": "Inheritance",
  "v2.profils.fiche.modifier": "Edit the profile",
  "v2.profils.fiche.motif_chargement": "Reading the reason…",
  "v2.profils.fiche.motif_illisible": "The reason for refusal could not be read.",
  "v2.profils.fiche.motif_refus": "Reason for refusal",
  "v2.profils.fiche.nouvelle_version": "New draft version",
  "v2.profils.fiche.personnes": "People holding it",
  "v2.profils.fiche.personnes.vide": "Nobody holds this profile.",
  "v2.profils.fiche.refus": "You cannot read this profile.",
  "v2.profils.fiche.reprendre_refuse": "Resume my refused draft",
  "v2.profils.fiche.retire": "Profile withdrawn.",
  "v2.profils.fiche.retirer": "Withdraw the profile",
  "v2.profils.fiche.retirer.consequence": "The profile can no longer be assigned; its published version is withdrawn.",
  "v2.profils.fiche.retirer.echec": "The profile was not withdrawn.",
  "v2.profils.fiche.retirer.reversibilite": "Its versions remain visible in the history.",
  "v2.profils.fiche.retirer.titre": "Withdraw the {{nom}} profile?",
  "v2.profils.fiche.retirer.verbe": "Withdraw",
  "v2.profils.fiche.tenu": "Held by people: remove it from them first.",
  "v2.profils.fiche.titre": "Profile — record",
  "v2.profils.fiche.tous": "All profiles",
  "v2.profils.fiche.version": "Version {{n}}",
  "v2.profils.fiche.version.auteur": "author {{qui}}",
  "v2.profils.fiche.version.auto": "self-approved",
  "v2.profils.fiche.version.publie_le": "published on {{date}}",
  "v2.profils.fiche.version.validateur": "validated by {{qui}} on {{date}}",
  "v2.profils.fiche.version_a_publier": "Open the version to publish",
  "v2.profils.fiche.versions": "Versions",
  "v2.profils.fiche.versions.vide": "No version.",
  "v2.profils.filtre.niveau": "Level",
  "v2.profils.filtre.origine": "Origin",
  "v2.profils.filtre.soumissions": "My submissions",
  "v2.profils.geste.en_cours": "In progress…",
  "v2.profils.heritage.profil_d_administration_qui_descend_jamais_surcharge": "Administration profile: it flows down to programmes and projects and is never overridden there.",
  "v2.profils.heritage.profil_de_travail_restreint_plus_bas": "Work profile: a profile set lower down replaces it on that space.",
  "v2.profils.isoles": "Individual rights in force",
  "v2.profils.isoles.col.droit": "Right",
  "v2.profils.isoles.col.ecart": "Deviation",
  "v2.profils.isoles.col.echeance": "End date",
  "v2.profils.isoles.col.objet": "On",
  "v2.profils.isoles.col.personne": "Person",
  "v2.profils.isoles.confirmer.consequence": "The right {{droit}} on {{objet}} stops being effective; it stays in the history.",
  "v2.profils.isoles.confirmer.reversibilite": "The right can be granted again.",
  "v2.profils.isoles.confirmer.titre": "Remove the individual right of {{qui}}?",
  "v2.profils.isoles.ecart": "Deviation reported",
  "v2.profils.isoles.echeance": "Until {{date}}",
  "v2.profils.isoles.echec": "The individual right was not removed.",
  "v2.profils.isoles.etat.en_vigueur": "In force",
  "v2.profils.isoles.etat.expire": "Expired",
  "v2.profils.isoles.etat.expire_bientot": "Expires soon",
  "v2.profils.isoles.retire": "Individual right removed.",
  "v2.profils.isoles.retirer": "Remove",
  "v2.profils.isoles.retirer.nom": "Remove the individual right of {{qui}}",
  "v2.profils.isoles.retirer.nom_programme": "Remove the individual right of {{qui}} on programme {{objet}}",
  "v2.profils.isoles.retirer.nom_projet": "Remove the individual right of {{qui}} on project {{objet}}",
  "v2.profils.isoles.sans_fin": "No end date",
  "v2.profils.isoles.vide": "No individual right in force.",
  "v2.profils.isoles.voir_membre": "View member {{qui}}",
  "v2.profils.liste": "Profiles",
  "v2.profils.liste.vide": "No profile matches these filters.",
  "v2.profils.niveau.organisation": "Organisation",
  "v2.profils.niveau.plateforme": "Platform",
  "v2.profils.niveau.programme": "Programme",
  "v2.profils.niveau.projet": "Project",
  "v2.profils.niveau.tous": "All levels",
  "v2.profils.onglet.membres": "Members",
  "v2.profils.onglet.profils": "Profiles",
  "v2.profils.onglet.regles": "Access rules",
  "v2.profils.onglet.revue": "Refusal review",
  "v2.profils.onglets": "Organisation access",
  "v2.profils.origine.depart": "Platform starting profile",
  "v2.profils.origine.organisation": "Organisation profile",
  "v2.profils.origine.tous": "All origins",
  "v2.profils.recherche": "Search for a right",
  "v2.profils.recherche.aide": "A right label or code: the profiles that hold it.",
  "v2.profils.recherche.deux_caracteres": "Type at least 2 characters.",
  "v2.profils.recherche.effacer": "Clear the search",
  "v2.profils.recherche.qui_le_tiennent": "Profiles that hold this right.",
  "v2.profils.sans_organisation": "No organisation in this session.",
  "v2.profils.soumissions.brouillons": "My drafts",
  "v2.profils.soumissions.en_validation": "My submissions under validation",
  "v2.profils.soumissions.refusees": "My refused submissions",
  "v2.profils.soumissions.toutes": "All",
  "v2.profils.titre": "Organisation profiles",
  "v2.profils.voir": "View",
  "v2.profils.voir.nom": "View the {{nom}} profile"
}
